import React from 'react';
import { get } from '../api/api';
import {
  Box,
  Card,
  CircularProgress,
  Typography,
} from '@mui/material';
import { camel2title } from '../utils/stringUtils';
import { isIsoDate } from '../utils/isIsoDate';
import { findByIdLinks } from '../configs/app.config';
import axios from 'axios';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { ContentCopy } from '@mui/icons-material';
import { formatterDate } from '../utils/formatter';

let exp = [];


const parseItemResource = (item, resource) => {
  let parsedName = item?.name?.replace('.id', 'Id');
  if (parsedName.includes('.')) parsedName = parsedName?.replace(/.*\./, '');
  if (item?.name === 'id') parsedName = `${resource.name}Id`;
  return findByIdLinks[parsedName]?.replace(`:${parsedName}`, item?.id);
};

const objToNodes = (obj, index) => {
  exp = [0];
  const [children] = objToNodesRec(obj, 1);
  const res = {
    id: 0,
    name: 'Properties',
    children: children
  }
  return res;
}
const objToNodesRec = (obj, index) => {
  const res = []
  let nextIndex = index;
  if (obj && typeof obj == 'object') {
    const entries = Object.entries(obj);

    for (var i = 0; i < entries.length; i++) {

      const propertyName = camel2title(entries[i][0])

      if (entries[i][1] && typeof entries[i][1] == 'object') {
        exp.push(nextIndex);
        const [children, deepIndex] = objToNodesRec(entries[i][1], nextIndex + 1);
        if (children.length > 0) {
          res.push(
            {
              id: nextIndex,
              name: propertyName,
              children: children
            }
          );
        }
        else {
          res.push(
            {
              id: nextIndex,
              name: propertyName,
              value: 'N/A'
            }
          );
        }
        nextIndex = deepIndex + 1;
      }
      else {
        res.push({
          id: nextIndex++,
          name: propertyName,
          value: entries[i][1] !== null && entries[i][1] !== undefined ? isIsoDate(entries[i][1])
            ? formatterDate(entries[i][1])
            : entries[i][1].toString()
            : 'N/A'
        })
      }
    }
  }
  else {
    // console.log(obj)
  }
  return [res, nextIndex];
}

const getTreeItemsFromData = obj => {

  const renderTree = (nodes) => (
    <TreeItem key={nodes.id} nodeId={nodes.id}
      label={
        <Box>
          <Typography noWrap>
            {nodes.name}: <span style={{ color: '#BCBCBC' }}>{nodes.value}</span>
          </Typography>
        </Box>
      }
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map((node) => renderTree(node))
        : null}
    </TreeItem>

    // <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
    //   {Array.isArray(nodes.children)
    //     ? nodes.children.map((node) => renderTree(node))
    //     : null}
    // </TreeItem>
  );


  return (
    <TreeView
      aria-label="rich object"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpanded={[0]}
      defaultExpandIcon={<ChevronRightIcon />}
      sx={{ height: '100%', width: '100%', overflowY: 'auto' }}
    >
      {renderTree(obj)}
    </TreeView>
  );
};

const copyToClipboard = (item) => {
  document.addEventListener('copy', (e) => {
    e.clipboardData.setData('text/plain', (JSON.stringify(item, null, 2)));
    e.preventDefault();
    document.removeEventListener('copy', null);
  });
  document.execCommand('copy');
}

export default function SingleItemBox(props) {
  const [data, setData] = React.useState(null);
  const [dataTreeFormat, setDataTreeFormat] = React.useState(null);

  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const source = axios.CancelToken.source();


    setLoading(true);
    if(props.item.object) {

      setData(props.item.object, 0);
      setDataTreeFormat(objToNodes(props.item.object, 0));
      setLoading(false);
    }
    else {
      const url = parseItemResource(props.item, props.resource);
      if (!url) return;
      get(url, null, {
        token: props.auth.token,
      })
        .then((res) => {
          setData(res.data, 0);
          setDataTreeFormat(objToNodes(res.data, 0));
          setLoading(false);
        })
        .catch((err) => {
          props.setAlert({ message: err.message, severity: 'error', open: true });
          setLoading(false);
        });
    }
    
    
    return () => {
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Box sx={{ margin: '0 auto' }}>
      {loading && <CircularProgress sx={{ margin: '0 auto' }} />}
      {!loading && data && (
        <Box>
          <Typography variant='h5' noWrap inline display="inline">
            {(props.item.object ? 'Details' : 
              (props.item?.name === 'id'
              ? camel2title(props.resource.name)
              : camel2title(props.item?.name).replace('id', '')))} 
          </Typography>
          <Tooltip
            title='Copy Item to Clipboard'
          >
            <IconButton
              sx={{
                color: 'white',
              }}
              aria-label='copy'
              onClick={() => {
                copyToClipboard(data);
              }}
            >
              <ContentCopy />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      {!loading && dataTreeFormat && (
        <Card
          sx={{
            textAlign: 'left',
            display: 'grid',
            padding: '20px',
          }}
        >
          {getTreeItemsFromData(dataTreeFormat)}
        </Card>
      )}
    </Box>
  );
}
